import React from "react";
import { motion } from "framer-motion";
import { fadeUp } from "../../constants/animations";

export default function SectionHeading({ label, title, description, centered = false }) {
  return (
    <motion.div
      {...fadeUp}
      className={`mb-12 ${centered ? "text-center" : ""}`}
      data-testid="section-heading"
    >
      <div className={`flex items-center gap-3 mb-4 ${centered ? "justify-center" : ""}`}>
        <div className="h-px w-10 bg-[#E8902A]" />
        <span className="font-heading font-bold text-xs tracking-widest uppercase text-[#E8902A]">
          {label}
        </span>
        <div className="h-px w-10 bg-[#E8902A]" />
      </div>
      <h2 className="font-heading font-black text-4xl md:text-5xl text-white leading-tight mb-4">
        {title}
      </h2>
      {description && (
        <p className="text-slate-400 text-lg leading-relaxed max-w-2xl">
          {description}
        </p>
      )}
    </motion.div>
  );
}
